// Banner.js
import React from 'react';
import '../css/index2.css';
const AboutBanner2 = () => {
    
  return (
    <div class="about-me-header">
       <div class="image-content">
            <img src="images/me2.png" alt="About Me" />
        </div>
        <div class="text-content">
            <p>
            I’m not just a writer or a painter—I focus on creating deep connections through characters with unique traits, often using personification to evoke strong emotions. My biggest inspiration comes from music and cinema, where I love taking clichés, twisting them, and making them interesting again.
            <br /> <br/>
            In writing, my strength lies in portraying real, flawed characters, exploring their emotions, and bringing depth to the narrative. I also enjoy bending stereotypes, making my characters feel authentic and relatable.
            <br /> <br />
            Painting, on the other hand, is my escape. It's a way to unwind, letting my feelings guide me without overthinking.


            </p>
        </div>
        
</div>

    
  );
};

export default AboutBanner2;
